"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profile = exports.Profiler = void 0;
var newSection = function () { return ({
    current: null,
    readings: [],
}); };
var state = {
    start: 0,
    data: {},
};
var report = function (filter) {
    if (filter === void 0) { filter = 'zzzzz'; }
    var total = "Total: ".concat(performance.now() - state.start, "ms");
    var sections = Object.keys(state.data)
        .filter(function (x) { return !new RegExp(filter).exec(x); })
        .map(function (x) {
        var readings = state.data[x].readings;
        var title = "".concat(x, " (").concat(readings.length, "):");
        var sum = "    Sum= ".concat(readings.reduce(function (a, c) { return a + c; }), "ms");
        var avg = "    Avg= ".concat(readings.reduce(function (a, c) { return a + c; }) / readings.length, "ms");
        var min = "    Min= ".concat(Math.min.apply(Math, __spreadArray([], __read(readings), false)), "ms");
        var max = "    Max= ".concat(Math.max.apply(Math, __spreadArray([], __read(readings), false)), "ms");
        // const lines = [`    Count: ${readings.length}`];
        // const lines = readings.map(r => `   ${r}ms`);
        return [title, sum, avg, min, max].join('\n');
    });
    return [total].concat(sections).join('\n');
};
var ProfilerNull = {
    start: function () {
        // fo eslint
    },
    stop: function () {
        return 'Profiler disabled.';
    },
    enter: function (_section) {
        // fo eslint
    },
    exit: function (_section) {
        // fo eslint
    }
};
var ProfilerImpl = {
    start: function () {
        state.start = performance.now();
        state.data = {};
    },
    stop: function (filter) {
        return report(filter);
    },
    enter: function (section) {
        var _a;
        var s = (_a = state.data[section]) !== null && _a !== void 0 ? _a : (state.data[section] = newSection());
        if (s.current !== null)
            throw new Error("Profiler: cannot recurse into ".concat(section, "."));
        s.current = performance.now();
    },
    exit: function (section) {
        var s = state.data[section];
        if (!s || s.current === null)
            throw new Error("Profiler: cannot exit ".concat(section, " without entering first."));
        s.readings.push(performance.now() - s.current);
        s.current = null;
    }
};
var ProfilerControls = {
    setEnabled: function (value) {
        if (value)
            Object.assign(this, ProfilerImpl);
        else
            Object.assign(this, ProfilerNull);
    },
};
exports.Profiler = Object.assign(ProfilerControls, ProfilerNull);
var profile = function (section) {
    return function (target, propertyKey, descriptor) {
        var original = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                exports.Profiler.enter(section);
                return original.apply(this, args);
            }
            finally {
                exports.Profiler.exit(section);
            }
        };
        return descriptor;
    };
};
exports.profile = profile;
